<template>
    <div style="text-align: center">
        <el-tooltip popper-class="td-remark-popper" :popper-append-to-body="false" enterable
            v-if="text != null && text != '' && text.length > 14"
            class="item" effect="dark" :content="text" placement="top">
            <el-button>{{ text.slice(0, 14) + '...' }}</el-button>
        </el-tooltip>
        <p v-else style="text-align: center;">{{ text }}</p>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        text: {
            type: [String],
            default: '',
        }
    },
}
</script>

<style lang=scss scoped>
p {
    font-size: 14px;
    color: #000;
    text-align: left;
}

.orver_h3 {
    font-weight: bold;
}

::v-deep .el-button {
    margin: 0;
    border: 0;
    background: none;
    //width: 12rem;
    //height: 100px;
    white-space: normal;
    overflow: hidden; //超出隐藏，其余内容不可见
    text-overflow: ellipsis; //文本溢出后用省略号显示
    color: #000;
    border: 0 !important;
    text-align: center;

    span {
        //display: block;
        font-size: 14px;
        color: #000;
        text-align: center;
    }
}
</style>

<style lang="scss">
.td-remark-popper {
    max-width: 220px !important;
    white-space: normal !important;
    word-break: break-all !important;
    line-height: 1.5;
}
</style>